"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3192,8773,5312],{

/***/ 45427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ secondsToDuration; },
/* harmony export */   "p": function() { return /* binding */ formatDate; }
/* harmony export */ });
//converts integer(seconds) into the duration
function secondsToDuration(seconds) {
  var hrs = Math.floor(seconds / 3600);
  var mins = Math.floor(seconds % 3600 / 60).toString().padStart(2, '0');
  var secs = (seconds % 60).toString().padStart(2, '0');
  return hrs > 0 ? "".concat(hrs, ":").concat(mins, ":").concat(secs) : "".concat(mins, ":").concat(secs);
} // //gets the date only from timestamp - DD:MM:YYYY
// export function formatDate(isoString) {
//     const date = new Date(isoString);
//     const day = date.getDate().toString().padStart(2, '0');
//     const month = (date.getMonth() + 1).toString().padStart(2, '0'); // months are 0-based
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
// }

function formatDate(isoString) {
  var hindiMonths = ['जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर'];
  var date = new Date(isoString);
  var day = date.getDate().toString().padStart(2, '0');
  var monthName = hindiMonths[date.getMonth()];
  var year = date.getFullYear();
  return "".concat(day, " ").concat(monthName, " ").concat(year);
}

/***/ }),

/***/ 78773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35005);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30767);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _templateObject;








var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  .modal {\n    height: 250px;\n    width: 350px;\n  }\n\n  .modalfooter .btn {\n    width: 10rem !important;\n  }\n"])));

var CustomPopup = function CustomPopup(_ref) {
  var showModal = _ref.showModal,
      onClose = _ref.onClose;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      contentClassName: "modal login-next",
      show: showModal,
      centered: true,
      dialogClassName: "frist-login",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "RegiModalBody",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "this_feature",
                defaultMessage: "\u092F\u0939 \u092B\u0940\u091A\u0930 \u0907\u0938\u094D\u0924\u0947\u092E\u093E\u0932 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0932\u0949\u0917\u093F\u0928 \u0915\u0930\u0947\u0902"
              })
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Footer */ .Z.Footer, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "modalfooter",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "d-flex justify-content-between flex-direction-row",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              variant: "primary",
              type: "button",
              onClick: function onClick() {
                return router.push({
                  pathname: "/login",
                  query: {
                    callbackUrl: window.location.href
                  }
                });
              },
              children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "signin",
                defaultMessage: "\u0938\u093E\u0907\u0928 \u0907\u0928 \u0915\u0930\u0947\u0902"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              variant: "primary",
              type: "button",
              onClick: onClose,
              children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "close",
                defaultMessage: "\u092C\u0902\u0926 \u0915\u0930\u0947\u0902"
              })]
            })]
          })
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (CustomPopup);

/***/ }),

/***/ 73192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ updatedNewsDetail_MoreEpisodes; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(2185);
// EXTERNAL MODULE: ./src/redux/actions/seriesAction.js
var seriesAction = __webpack_require__(98033);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/category/show/FollowButton.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function FollowButton(_ref) {
  var show = _ref.show,
      size = _ref.size,
      setLoginPrompt = _ref.setLoginPrompt;

  var _useState = (0,node_modules_react.useState)(show),
      showData = _useState[0],
      setShowData = _useState[1];

  var _useSelector = (0,es/* useSelector */.v9)(function (_ref2) {
    var AuthReducer = _ref2.AuthReducer;
    return AuthReducer;
  }),
      userLocalDetail = _useSelector.userLocalDetail;

  var _useSession = (0,react.useSession)(),
      session = _useSession.data;

  var dispatch = (0,es/* useDispatch */.I0)(); //handle follow click

  var handleFollowed = function handleFollowed(_id, postSlug, title) {
    var _session$user;

    if (userLocalDetail !== null && userLocalDetail !== void 0 && userLocalDetail.id || session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.email) {
      var type = 'video';
      dispatch((0,seriesAction/* followedSeriesData */.bx)({
        _id: _id,
        type: type,
        postSlug: postSlug
      }));
      setShowData(_objectSpread(_objectSpread({}, showData), {}, {
        isFollowed: showData !== null && showData !== void 0 && showData.isFollowed ? false : true
      }));
    } else {
      setLoginPrompt(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      onClick: function onClick() {
        handleFollowed(showData === null || showData === void 0 ? void 0 : showData._id, showData === null || showData === void 0 ? void 0 : showData.postSlug, showData === null || showData === void 0 ? void 0 : showData.title);
      },
      className: "btn m-0 p-0 py-1 d-flex justify-content-center gap-2 align-items-center",
      style: {
        cursor: "pointer",
        border: "2px solid #D8358A",
        color: showData !== null && showData !== void 0 && showData.isFollowed ? "white" : "#D8358A",
        backgroundColor: !(showData !== null && showData !== void 0 && showData.isFollowed) ? "white" : "#D8358A",
        fontSize: size.width < 1000 ? "12px" : "14.75px",
        fontWeight: "500"
      },
      children: [!(showData !== null && showData !== void 0 && showData.isFollowed) ? /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: showData !== null && showData !== void 0 && showData.isFollowed ? "white" : "#D8358A",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.95633 0.00146484H15.1177C18.4563 0.00146484 20.3612 1.88677 20.3612 5.23514V14.4063C20.3612 17.7351 18.4661 19.64 15.1275 19.64H5.95633C2.60796 19.64 0.722656 17.7351 0.722656 14.4063V5.23514C0.722656 1.88677 2.60796 0.00146484 5.95633 0.00146484ZM11.3464 10.6359H14.135C14.5867 10.6261 14.95 10.2627 14.95 9.81105C14.95 9.35937 14.5867 8.99605 14.135 8.99605H11.3464V6.22702C11.3464 5.77533 10.983 5.41202 10.5314 5.41202C10.0797 5.41202 9.71635 5.77533 9.71635 6.22702V8.99605H6.9375C6.72147 8.99605 6.51527 9.08443 6.35816 9.23172C6.21087 9.38883 6.1225 9.59405 6.1225 9.81105C6.1225 10.2627 6.48581 10.6261 6.9375 10.6359H9.71635V13.4147C9.71635 13.8664 10.0797 14.2297 10.5314 14.2297C10.983 14.2297 11.3464 13.8664 11.3464 13.4147V10.6359Z",
          fill: showData !== null && showData !== void 0 && showData.isFollowed ? "white" : "#D8358A"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M15.1378 1.87H7.30247C3.89907 1.87 1.87012 3.89895 1.87012 7.30235V15.1283C1.87012 18.541 3.89907 20.57 7.30247 20.57H15.1284C18.5318 20.57 20.5608 18.541 20.5608 15.1376V7.30235C20.5701 3.89895 18.5412 1.87 15.1378 1.87ZM15.6894 9.0695L10.388 14.3709C10.2571 14.5018 10.0794 14.5766 9.89242 14.5766C9.70542 14.5766 9.52777 14.5018 9.39687 14.3709L6.75082 11.7249C6.47967 11.4537 6.47967 11.0049 6.75082 10.7338C7.02197 10.4626 7.47077 10.4626 7.74192 10.7338L9.89242 12.8843L14.6983 8.0784C14.9695 7.80725 15.4183 7.80725 15.6894 8.0784C15.9606 8.34955 15.9606 8.789 15.6894 9.0695Z",
          fill: "white"
        })
      }), showData !== null && showData !== void 0 && showData.isFollowed ? "फ़ॉलोड" : "फॉलो करें"]
    })
  });
}

/* harmony default export */ var show_FollowButton = (FollowButton);
// EXTERNAL MODULE: ./src/components/category/show/utility.js
var utility = __webpack_require__(45427);
// EXTERNAL MODULE: ./src/components/shared/modal/customPopup.js
var customPopup = __webpack_require__(78773);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/api/constants.js
var constants = __webpack_require__(9041);
// EXTERNAL MODULE: ./src/utils/encryption.js
var encryption = __webpack_require__(34071);
// EXTERNAL MODULE: ./src/utils/cookieHelper.js
var cookieHelper = __webpack_require__(97160);
;// CONCATENATED MODULE: ./src/components/updatedNewsDetail/MoreEpisodes.jsx




function MoreEpisodes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MoreEpisodes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MoreEpisodes_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MoreEpisodes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















function MoreEpisodes(_ref) {
  var postData = _ref.postData,
      _ref$seriesSlug = _ref.seriesSlug,
      seriesSlug = _ref$seriesSlug === void 0 ? '' : _ref$seriesSlug,
      size = _ref.size;

  var _useState = (0,node_modules_react.useState)(null),
      episodes = _useState[0],
      setEpisodes = _useState[1];

  var _useState2 = (0,node_modules_react.useState)(null),
      seriesData = _useState2[0],
      setSeriesData = _useState2[1];

  var _useState3 = (0,node_modules_react.useState)(false),
      loginPrompt = _useState3[0],
      setLoginPrompt = _useState3[1];

  var _useState4 = (0,node_modules_react.useState)(true),
      hasMore = _useState4[0],
      setHasMore = _useState4[1];

  var _useState5 = (0,node_modules_react.useState)(2),
      skipPerPage = _useState5[0],
      setSkipPerPage = _useState5[1];

  var getMorePost1 = lodash_default().debounce( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _newPosts$result2, _newPosts$result2$ser, _newPosts$result2$ser2;

    var res, newPosts;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(constants/* baseUrl */.FH, "/series/series-details?postSlug=").concat(seriesData === null || seriesData === void 0 ? void 0 : seriesData.postSlug, "&limit=10&skip=").concat(isNaN(skipPerPage) ? "2" : skipPerPage, " "));

          case 2:
            res = _context.sent;
            _context.next = 5;
            return res.json();

          case 5:
            newPosts = _context.sent;
            // setPosts((post) => [...post, ...newPosts?.result?.series?.episodes]);
            setEpisodes(function (episodes) {
              var _newPosts$result, _newPosts$result$seri;

              return [].concat((0,toConsumableArray/* default */.Z)(episodes), (0,toConsumableArray/* default */.Z)(newPosts === null || newPosts === void 0 ? void 0 : (_newPosts$result = newPosts.result) === null || _newPosts$result === void 0 ? void 0 : (_newPosts$result$seri = _newPosts$result.series) === null || _newPosts$result$seri === void 0 ? void 0 : _newPosts$result$seri.episodes));
            });
            setSkipPerPage(function (skip) {
              return skip + 1;
            });

            if (!(newPosts !== null && newPosts !== void 0 && (_newPosts$result2 = newPosts.result) !== null && _newPosts$result2 !== void 0 && (_newPosts$result2$ser = _newPosts$result2.series) !== null && _newPosts$result2$ser !== void 0 && (_newPosts$result2$ser2 = _newPosts$result2$ser.episodes) !== null && _newPosts$result2$ser2 !== void 0 && _newPosts$result2$ser2.length)) {
              setHasMore(false);
            }

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 1000);

  (0,node_modules_react.useEffect)(function () {
    if (!seriesSlug) return;
    var bearerToken = null;

    try {
      var cookie = JSON.parse(decodeURIComponent((0,cookieHelper/* getCookie */.ej)('lallantop')));
      var token = (0,encryption/* decryptData */.o)(cookie === null || cookie === void 0 ? void 0 : cookie.encryptedToken);
      bearerToken = token;
    } catch (error) {
      console.error('API error:', error);
      bearerToken = null;
    }

    var fetchData = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _res$data, _res$data$result, _res$data$result$seri, _res$data2, _res$data2$result, res;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return axios_default().get("".concat("https://api.thelallantop.com", "/v1/series/series-details"), {
                  params: {
                    postSlug: seriesSlug,
                    limit: 10,
                    skip: 1
                  },
                  headers: MoreEpisodes_objectSpread({}, bearerToken && {
                    Authorization: "Bearer ".concat(bearerToken)
                  })
                });

              case 3:
                res = _context2.sent;
                // console.log(res.data);
                setEpisodes(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$result = _res$data.result) === null || _res$data$result === void 0 ? void 0 : (_res$data$result$seri = _res$data$result.series) === null || _res$data$result$seri === void 0 ? void 0 : _res$data$result$seri.episodes);
                setSeriesData(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$result = _res$data2.result) === null || _res$data2$result === void 0 ? void 0 : _res$data2$result.series);
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.error('API error:', _context2.t0);
                setEpisodes(null);
                setSeriesData(null);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetchData();
  }, [seriesSlug]);

  var handleClick = function handleClick(data) {
    var _data$permalink;

    window.location.href = data === null || data === void 0 ? void 0 : (_data$permalink = data.permalink) === null || _data$permalink === void 0 ? void 0 : _data$permalink.split(".com")[1];
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: episodes && (episodes === null || episodes === void 0 ? void 0 : episodes.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "rounded-4 bg-white ",
      style: {
        marginTop: "15px"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "d-flex p-2 justify-content-between align-items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              width: "145px",
              heigh: "51px"
            },
            className: "",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: (seriesData === null || seriesData === void 0 ? void 0 : seriesData.headingImageUrl) + "?width=200",
              alt: "playlist_img",
              className: "w-100 h-100 rounded-4"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "d-flex gap-2 align-items-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "d-flex gap-8 flex-column align-items-end",
              children: [seriesData && /*#__PURE__*/(0,jsx_runtime.jsx)(show_FollowButton, {
                show: seriesData,
                size: size,
                setLoginPrompt: setLoginPrompt
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "m-0 p-0",
                style: {
                  fontSize: "16px",
                  fontWeight: 400,
                  color: 'rgba(134, 134, 134, 1)'
                },
                children: [seriesData === null || seriesData === void 0 ? void 0 : seriesData.episodesCount, " \u090F\u092A\u093F\u0938\u094B\u0921\u094D\u0938"]
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "p-2 mt-2",
          style: {
            backgroundColor: "rgba(235, 14, 140, 1)"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "m-0 p-0 ",
            style: {
              fontWeight: 400,
              fontSize: "15.77px",
              color: "rgba(255, 255, 255, 1)"
            },
            children: "\u0905\u0928\u094D\u092F \u090F\u092A\u093F\u0938\u094B\u0921\u094D\u0938"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onScroll: getMorePost1,
        style: {
          maxHeight: "800px",
          overflowY: "auto"
        },
        children: episodes === null || episodes === void 0 ? void 0 : episodes.map(function (episode, ind) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onClick: function onClick() {
              return handleClick(episode);
            },
            className: "d-flex justify-content-between gap-2 align-items-start p-2",
            style: {
              flexDirection: (size === null || size === void 0 ? void 0 : size.width) < 700 ? "row-reverse" : "initial",
              backgroundColor: (episode === null || episode === void 0 ? void 0 : episode._id) == (postData === null || postData === void 0 ? void 0 : postData._id) ? "rgba(235, 14, 140, 0.1)" : "white",
              cursor: "pointer"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "m-0 p-0",
                style: {
                  fontWeight: 600,
                  fontSize: "15px",
                  width: "fit-content",
                  maxWidth: "240px"
                },
                children: episode === null || episode === void 0 ? void 0 : episode.title
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "m-0 p-0",
                style: {
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#999999"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  className: "me-1",
                  width: "18",
                  height: "18",
                  viewBox: "0 0 18 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M8.63536 1.97327C12.4102 1.97327 15.4714 5.03376 15.4714 8.80931C15.4714 12.5849 12.4102 15.6453 8.63536 15.6453C4.85981 15.6453 1.79932 12.5849 1.79932 8.80931C1.79932 5.03376 4.85981 1.97327 8.63536 1.97327Z",
                    stroke: "#999999",
                    "stroke-width": "1.43917",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M10.7942 8.80583C10.7942 8.22215 7.80256 6.35491 7.46319 6.69065C7.12382 7.02639 7.09119 10.5536 7.46319 10.921C7.83519 11.2897 10.7942 9.38951 10.7942 8.80583Z",
                    stroke: "#999999",
                    "stroke-width": "1.43917",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })]
                }), (0,utility/* secondsToDuration */.Q)(episode === null || episode === void 0 ? void 0 : episode.duration), "  ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "mx-0",
                  children: "   |  "
                }), " ", (0,utility/* formatDate */.p)(episode === null || episode === void 0 ? void 0 : episode.publishedAt)]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                maxWidth: "200px",
                minWidth: "120px",
                height: "70"
              },
              className: "rounded-4 border",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: (episode === null || episode === void 0 ? void 0 : episode.headingImageUrl) + "?width=200",
                className: "rounded-4",
                style: {
                  objectFit: "cover",
                  widthc: "163px",
                  height: "auto"
                }
              })
            })]
          }, ind);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(customPopup["default"], {
        showModal: loginPrompt,
        onClose: function onClose() {
          return setLoginPrompt(false);
        }
      })]
    }) : null
  });
}

/* harmony default export */ var updatedNewsDetail_MoreEpisodes = (MoreEpisodes);

/***/ })

}]);